import styled from 'styled-components';

const StyledInputContainer = styled.div`
	display: flex;
	align-items: center;

	* {
		cursor: pointer;
	}

	label {
		text-indent: 10px;
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: normal;
		font-size: 18px;
		user-select: none;
	}
`;

const StyledInputField = styled.input.attrs({ type: 'radio' })`
	width: 20px;
	height: 20px;
	border-radius: 50%;
	margin: 0 !important;
	text-indent: 10px;
	box-shadow: 0 0 0 1px white;
	background-color: transparent;
	appearance: none;
	cursor: pointer;
	transition: box-shadow 0.25s ease;

	&:checked {
		box-shadow: 0 0 0 1px yellow;
	}

	&:focus {
		outline: none;
	}

	&::before {
		content: '';
		display: block;
		width: 20px;
		height: 20px;
		padding: 5px;
		border-radius: 50%;
		background-color: yellow;
		background-clip: content-box;
		transform: scale(0);
		transition: transform 0.25s ease;
	}

	&:checked::before {
		transform: scale(1);
	}
`;

export { StyledInputContainer, StyledInputField };
